import { ReportGrid } from '@/features/ReportGrid';
import { useDocumentTitle, useResetQueryState } from '@/hooks';

export default function ReportsPage() {
    useDocumentTitle('reports');
    useResetQueryState();

    return <ReportGrid />;
}
